// start:ng42.barrel
import './portal-page.component';
import './portal.component';
// end:ng42.barrel

